import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"pix-toast-container\">\n  {{#each this.pixToast.content as |toast|}}\n    <PixToast @toast={{toast}} @closeButtonAriaLabel={{@closeButtonAriaLabel}} />\n  {{/each}}\n</div>", {
  moduleName: "@1024pix/pix-ui/components/pix-toast-container.hbs"
});